// Exports the "fullscreen" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/fullscreen')
//   ES2015:
//     import 'tinymce/plugins/fullscreen'
require('./plugin.js');


// WEBPACK FOOTER //
// ./src/packages/tinymce/plugins/fullscreen/index.js